<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/gaji-periode">Daftar Periode Penggajian</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/gaji-history">Daftar Riwayat Gaji</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Rekap Penggajian
        </li>
      </ol>
    </nav>

    <h5 class="content-block">Rekap Gaji</h5>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Peraturan Rekap Gaji</p>

        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxDateBox
                :show-clear-button="true"
                :use-mask-behavior="true"
                :input-attr="{ 'aria-label': 'Date' }"
                type="date"
                displayFormat="monthAndYear"
                :calendar-options="calendarMonthYear"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="tglGajiAwal"
                label="Periode Rekap Awal"
                placeholder="Periode Rekap Awal"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxDateBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxDateBox
                :show-clear-button="true"
                :use-mask-behavior="true"
                :input-attr="{ 'aria-label': 'Date' }"
                type="date"
                displayFormat="monthAndYear"
                :calendar-options="calendarMonthYear"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="tglGajiAkhir"
                label="Periode Rekap Akhir"
                placeholder="Periode Rekap Akhir"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxDateBox>
            </div>

            <div class="col" style="padding-left: 10px">
              <DxCheckBox
                :enable-three-state-behavior="true"
                :text="checkboxText"
                :value="approvedOnly"
                v-model="approvedOnly"
                @valueChanged="checkboxChanged"
              />
            </div>

            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="validateFilter"
                text="Lihat Rekap Gaji"
                styling-mode="filled"
                type="default"
                class="validate"
                style="float: left"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-block">
      <DxPopup
        :visible="popupLoadingVisible"
        title="Generating rekap gaji..."
        :drag-enabled="false"
        :hide-on-outside-click="false"
        width="300"
        :height="130"
      >
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border"
            style="width: 3rem; height: 3rem"
            role="status"
          ></div>
        </div>
      </DxPopup>

      <div class="dx-card responsive-paddings">
        <DxTabPanel
          id="tabpanel"
          :data-source="tabSource"
          v-model:selected-index="tabPanelIndex"
          :loop="loop"
          :animation-enabled="animationEnabled"
          :swipe-enabled="swipeEnabled"
          item-title-template="title"
          @titleClick="tabTitleClick"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #tDireksi>
            <DxPivotGrid
              id="pivotDireksi"
              ref="pivotDireksiRef"
              :allow-sorting-by-summary="true"
              :allow-sorting="true"
              :allow-filtering="true"
              :allow-expand-all="true"
              :show-borders="true"
              :data-source="dataSourceDireksi"
              @exporting="onExporting($event, 'Direksi')"
            >
              <DxFieldChooser :enabled="false" />
              <DxExport :enabled="true" />
            </DxPivotGrid>
          </template>
          <template #tTetap>
            <DxPivotGrid
              id="pivotTetap"
              :allow-sorting-by-summary="true"
              :allow-sorting="true"
              :allow-filtering="true"
              :allow-expand-all="true"
              :show-borders="true"
              :data-source="dataSourceTetap"
              @exporting="onExporting($event, 'Pegawai Tetap')"
            >
              <DxFieldChooser :enabled="false" />
              <DxExport :enabled="true" />
            </DxPivotGrid>
          </template>
          <template #tHonor>
            <DxPivotGrid
              id="pivotHonor"
              :allow-sorting-by-summary="true"
              :allow-sorting="true"
              :allow-filtering="true"
              :allow-expand-all="true"
              :show-borders="true"
              :data-source="dataSourceHonor"
              @exporting="onExporting($event, 'Honor')"
            >
              <DxFieldChooser :enabled="false" />
              <DxExport :enabled="true" />
            </DxPivotGrid>
          </template>
          <template #tKontrak>
            <DxPivotGrid
              id="pivotKontrak"
              :allow-sorting-by-summary="true"
              :allow-sorting="true"
              :allow-filtering="true"
              :allow-expand-all="true"
              :show-borders="true"
              :data-source="dataSourceKontrak"
              @exporting="onExporting($event, 'Kontrak')"
            >
              <DxFieldChooser :enabled="false" />
              <DxExport :enabled="true" />
            </DxPivotGrid>
          </template>
        </DxTabPanel>
      </div>
    </div>
    <!-- <div v-for="(perubahan, index) in storePerubahan" :key="index">
      <div class="content-block">
        <div class="dx-card responsive-paddings">
          <h3>{{ perubahan.title }}</h3>
          <div v-html="printKet(perubahan.data)"></div>
        </div>
      </div>
    </div> -->
    <div class="content-block" v-if="storePerbandingan">
      <DxButton
        icon="download"
        @click="downloadExcelPerbandingan"
        text="Download Data Perbandingan Gaji / Upah"
        styling-mode="outlined"
        type="default"
      />
      <DxButton
        icon="print"
        @click="printPerbandingan"
        text="Print Perbandingan Gaji / Upah"
        styling-mode="outlined"
        type="default"
        style="margin-left: 10px"
      />
    </div>

    <div v-for="(perbandingan, index) in storePerbandingan" :key="index">
      <div class="content-block">
        <div class="dx-card responsive-paddings">
          <h3>{{ perbandingan.title }}</h3>

          <table class="table table-bordered table-responsive">
            <thead>
              <tr>
                <th>No</th>
                <th>Uraian</th>
                <th>{{ perbandingan.bulan1 }}</th>
                <th>{{ perbandingan.bulan2 }}</th>
                <th>Selisih</th>
                <th>Keterangan</th>
                <th>Perubahan Data Pegawai di {{ perbandingan.bulan2 }}</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(val, index) in perbandingan.dataTetap" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ val.komponen }}</td>
                <td>{{ formatNumber(val.bulan1) }}</td>
                <td>{{ formatNumber(val.bulan2) }}</td>
                <td>
                  {{ formatNumber(val.bulan2 - val.bulan1) }}
                </td>

                <td @click="editCell(index, 'name')">
                  <span v-if="!can('gaji-create')">{{ val.keterangan }}</span>
                  <!-- //v-else -->

                  <!-- v-model="row.name" -->
                  <textarea
                    v-else
                    type="text"
                    class="form-control"
                    v-model="val.keterangan"
                    rows="2"
                  ></textarea>
                </td>

                <!-- <td>{{ printKet(perbandingan.ket) }}</td> -->
                <td rowspan="11" v-if="printKetJustOnce(index)">
                  <div v-html="printKet(perbandingan.dataKet)"></div>
                </td>
              </tr>

              <tr>
                <td></td>
                <td>Total</td>
                <td>{{ formatNumber(perbandingan.total1) }}</td>
                <td>{{ formatNumber(perbandingan.total2) }}</td>
                <td>
                  {{ formatNumber(perbandingan.total2 - perbandingan.total1) }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="col" style="padding-left: 10px"> -->
          <div>
            <p class="text-muted font-weight-light">
              dibuat oleh
              {{ perbandingan.created_at_text }}
              <!-- {{ commonFunction.viewCreatedByUser(perbandingan) }} -->
              , diupdate oleh
              {{ perbandingan.updated_at_text }}
              <!-- {{ commonFunction.viewUpdatedByUser(perbandingan) }} -->
            </p>
          </div>

          <DxButton
            v-if="can('gaji-create')"
            @click="simpanKeterangan(perbandingan, index)"
            text="Simpan Keterangan"
            styling-mode="filled"
            type="default"
            class="validate"
            style="float: right"
          />
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.text-muted {
  color: #6c757d; /* Typically a muted gray color */
}
</style>

<script>
import * as commonFunction from "@/utils/common-function.js";
import notify from "devextreme/ui/notify";
import auth from "@/auth";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import * as XLSX from "xlsx";
import _ from "lodash";
import { DxCheckBox } from "devextreme-vue/check-box";
import { DxPopup } from "devextreme-vue/popup";
import { DateTime } from "luxon";
import DxDateBox from "devextreme-vue/date-box";
import DxTabPanel from "devextreme-vue/tab-panel";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import DxPivotGrid, {
  DxExport,
  DxFieldChooser,
} from "devextreme-vue/pivot-grid";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { exportPivotGrid } from "devextreme/excel_exporter";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import DxButton from "devextreme-vue/button";
import can from "@/haspermission";
const tabSource = [
  {
    id: 1,
    text: "Direksi",
    template: "tDireksi",
  },
  {
    id: 2,
    text: "Pegawai Tetap",
    template: "tTetap",
  },
  {
    id: 3,
    text: "Pekerja Honor",
    template: "tHonor",
  },
  {
    id: 4,
    text: "Pekerja Kontrak",
    template: "tKontrak",
  },
];

const settingSource = [
  {
    id: 1,
    text: "Bulan ini",
    val: "0",
  },
  {
    id: 2,
    text: "Tahun ini",
    val: "tahun",
  },
  {
    id: 3,
    text: "Tahun lalu",
    val: "tahunlalu",
  },
  {
    id: 4,
    text: "3 bulan terakhir",
    val: "3",
  },
  {
    id: 5,
    text: "12 bulan terakhir",
    val: "12",
  },
  {
    id: 6,
    text: "3 tahun terakhir",
    val: "36",
  },
];

export default {
  components: {
    DxTabPanel,
    DxExport,
    DxPivotGrid,
    DxFieldChooser,
    DxValidator,
    DxRequiredRule,
    DxButton,
    DxDateBox,
    DxPopup,
    DxCheckBox,
  },
  setup() {
    return { commonFunction };
  },
  data() {
    return {
      checkboxText: "Hanya rekap gaji yg sudah approved",
      pejabatDirum: null,
      pejabatKabagUmum: null,
      pejabatKasubagPersonalia: null,
      pejabat: null,
      approvedOnly: true,
      popupLoadingVisible: false,
      tglGajiAwal: null,
      tglGajiAkhir: null,
      calendarMonthYear: {
        maxZoomLevel: "year",
        minZoomLevel: "century",
      },
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      setting: "0",
      settingSource: settingSource,
      tabPanelIndex: 0,
      loop: false,
      animationEnabled: true,
      swipeEnabled: false,
      tabSource: tabSource,
      //---PIVOT
      storeKontrak: null,
      dataSourceKontrak: null,
      storeHonor: null,
      dataSourceHonor: null,
      storeTetap: null,
      dataSourceTetap: null,
      storeDireksi: null,
      dataSourceDireksi: null,
      storePerubahan: null,
      storePerbandingan: null,
      titleRekap: null,
      editingCell: {
        row: null,
        field: null,
      },

      //---/PIVOT
    };
  },
  async mounted() {
    if (this.$route.query.filter) {
      let filter = this.$route.query.filter;
      this.tglGajiAwal = filter;
      this.tglGajiAkhir = filter;
      this.validateFilterFromUrl();
    }

    // await this.fetchDataPejabatPembuatGaji();
  },
  methods: {
    printPerbandingan() {
      const url = this.$router.resolve({
        name: "gaji-rekap-print",

        query: {
          tglAwal: this.formatDateISO(this.tglGajiAwal),
          tglAkhir: this.formatDateISO(this.tglGajiAkhir),
          statusGaji: this.approvedOnly,
        },
      }).href;
      window.open(url, "_blank");
    },
    async simpanKeterangan(perbandingan) {
      let data = {
        tgl_awal: perbandingan.tgl_awal,
        tgl_akhir: perbandingan.tgl_akhir,
        created_by_user_id: auth.getUser().id,
        updated_by_user_id: auth.getUser().id,
      };
      perbandingan.dataTetap.forEach((i) => {
        data[i.variable] = i.keterangan;
      });

      console.log("simpanKeterangan data", data);

      try {
        const response = await axios.post(
          `${API_BASE_URL}/gaji_perbandingan`,
          data,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "content-type": "application/json",
            },
          },
        );
        if (response.data.status) {
          notify("Berhasil mengubah keterangan perbandingan gaji", "success");
        } else {
          notify("Gagal mengubah keterangan perbandingan gaji", "error");
        }
      } catch (error) {
        console.log(error);
        notify("Gagal mengubah keterangan perbandingan gaji", "error");
      }
    },
    can,
    editCell(rowIndex, field) {
      this.editingCell = { row: rowIndex, field };
    },
    isEditing(rowIndex, field) {
      return (
        this.editingCell.row === rowIndex && this.editingCell.field === field
      );
    },
    checkboxChanged(e) {
      if (e.value) this.checkboxText = "Hanya rekap gaji yg sudah approved";
      else if (e.value === false)
        this.checkboxText = "Hanya rekap gaji yg belum approved";
      else this.checkboxText = "Rekap semua gaji";
    },
    async fetchDataPejabatPembuatGaji() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      // const response = await axios.get(`${API_BASE_URL}/pejabat_gaji`, config);
      const data = {
        tgl_gaji: null,
      };

      const response = await axios.post(
        `${API_BASE_URL}/pejabat_gaji`,
        data,
        config,
      );

      this.pejabatDirum = response.data.dirum.simpeg_pegawai.nama;
      this.pejabatKabagUmum = response.data.kabagUmum.simpeg_pegawai.nama;
      this.pejabatKasubagPersonalia =
        response.data.kasubagPersonalia.simpeg_pegawai.nama;
    },
    formatNumberTerbilang(value) {
      if (typeof value === "string") {
        value = value.replace(/\./g, "");
      }

      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];

        return _.startCase(angkaTerbilang(stringValue));
        // Add thousands separator
        // return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    wbAoa(worksheet, text, cell) {
      XLSX.utils.sheet_add_aoa(worksheet, [[text]], {
        origin: cell,
      });
    },
    excelPerbandingan(workbook, sheetName) {
      var row = 3;
      const ws = workbook.Sheets[sheetName];

      _.forEach(this.storePerbandingan, (val) => {
        this.wbAoa(ws, val.title.toUpperCase(), "A" + row);
        row += 1;
        this.wbAoa(ws, "URAIAN", "B" + row);
        this.wbAoa(ws, "BULAN", "C" + row);
        this.wbAoa(ws, "SELISIH", "E" + row);
        this.wbAoa(ws, "KETERANGAN", "F" + row);
        row += 1;
        this.wbAoa(ws, val.bulan1, "C" + row);
        this.wbAoa(ws, val.bulan2, "D" + row);
        this.wbAoa(ws, "NAIK/TURUN", "E" + row);
        this.wbAoa(ws, "KETERANGAN", "F" + row);
        row += 1;
        this.wbAoa(ws, "(Rp.)", "C" + row);
        this.wbAoa(ws, "(Rp.)", "D" + row);
        this.wbAoa(ws, "(Rp.)", "E" + row);
        row += 1;
        this.wbAoa(ws, "1", "A" + row);
        this.wbAoa(ws, "2", "B" + row);
        this.wbAoa(ws, "3", "C" + row);
        this.wbAoa(ws, "4", "D" + row);
        this.wbAoa(ws, "5", "E" + row);
        this.wbAoa(ws, "6", "F" + row);
        row += 2;

        _.forEach(val.dataTetap, (valKomponen, indexKomponen) => {
          this.wbAoa(ws, indexKomponen + 1, "A" + row);
          this.wbAoa(ws, valKomponen.komponen, "B" + row);
          this.wbAoa(ws, valKomponen.bulan1, "C" + row);
          this.wbAoa(ws, valKomponen.bulan2, "D" + row);
          this.wbAoa(ws, valKomponen.bulan2 - valKomponen.bulan1, "E" + row);
          this.wbAoa(ws, valKomponen.keterangan, "F" + row);
          row += 2;
        });

        this.wbAoa(ws, "JUMLAH", "A" + row);
        this.wbAoa(ws, val.total1, "C" + row);
        this.wbAoa(ws, val.total2, "D" + row);
        this.wbAoa(ws, val.total2 - val.total1, "E" + row);
        row += 1;
        this.wbAoa(ws, "Gaji yg dibayar", "A" + row);
        this.wbAoa(ws, val.total2, "D" + row);
        row += 1;
        this.wbAoa(
          ws,
          "Terbilang: ==== " + this.formatNumberTerbilang(val.total2) + " ====",
          "A" + row,
        );
        row += 3;
        this.wbAoa(ws, "Mengetahui:", "B" + row);
        this.wbAoa(ws, "Diperiksa", "D" + row);
        this.wbAoa(ws, "Dibuat Oleh:", "F" + row);
        row += 4;
        this.wbAoa(ws, this.pejabat.dirum.nama, "B" + row);
        this.wbAoa(ws, this.pejabat.pejabatMengetahui.nama, "D" + row);
        this.wbAoa(ws, this.pejabat.pejabatMembuat.nama, "F" + row);
        row += 1;
        this.wbAoa(ws, "Direktur Umum", "B" + row);
        this.wbAoa(ws, this.pejabat.pejabatMengetahui.jabatan, "D" + row);
        this.wbAoa(ws, this.pejabat.pejabatMembuat.jabatan, "F" + row);
        row += 10;
      });
    },

    excelRekap2(workbook, sheetName, data) {
      const ws = workbook.Sheets[sheetName];
      var row = 1;

      _.forEach(data, (table) => {
        // console.log("excelrekap", table);
        var rowTgl = true;
        _.forEach(table, (val) => {
          if (rowTgl) {
            this.wbAoa(
              ws,
              "REKAP GAJI/UPAH " +
                _.replace(this.convertTglIndonesia(val.value), /^1\s/, ""),
              "A" + row,
            );
            rowTgl = false;
            row += 1;
            this.wbAoa(ws, "KETERANGAN", "A" + row);
            this.wbAoa(ws, "GAPOK", "B" + row);
            this.wbAoa(ws, "TUNJANGAN", "C" + row);
            this.wbAoa(ws, "PERUSAHAAN", "C" + (row + 1));
            this.wbAoa(ws, "JABATAN", "D" + (row + 1));
            this.wbAoa(ws, "KEMAHALAN", "E" + (row + 1));
            this.wbAoa(ws, "AIR", "F" + (row + 1));
            this.wbAoa(ws, "TRANSPORT", "G" + (row + 1));
            this.wbAoa(ws, "PANGAN", "H" + (row + 1));
            this.wbAoa(ws, "KESEHATAN", "I" + (row + 1));

            this.wbAoa(ws, "POT. ", "J" + row);
            this.wbAoa(ws, "PERSONALIA", "J" + (row + 1));
            this.wbAoa(ws, "JUMLAH", "K" + row);
            this.wbAoa(ws, "BRUTO", "K" + (row + 1));
            this.wbAoa(ws, "T. PPH", "L" + row);
            this.wbAoa(ws, "JUMLAH", "M" + row);
            this.wbAoa(ws, "POT.", "N" + row);
            this.wbAoa(ws, "KESEHATAN", "N" + (row + 1));
            this.wbAoa(ws, "BPJS TK", "O" + row);
            this.wbAoa(ws, "3 PROGRAM", "O" + (row + 1));
            this.wbAoa(ws, "BPJS TK", "P" + row);
            this.wbAoa(ws, "4 PROGRAM", "P" + (row + 1));

            this.wbAoa(ws, "PENSIUN", "Q" + row);
            this.wbAoa(ws, "JIWASRAYA", "Q" + (row + 1));
            this.wbAoa(ws, "POT. PPH", "R" + row);
            this.wbAoa(ws, "YANG", "S" + row);
            this.wbAoa(ws, "DITERIMA", "S" + (row + 1));
            row += 2;
          } else {
            //print data   TETAP
            console.log("excelrekap valtetapvalue", val);
            // this.wbAoa(ws, val.key, "A" + row);
            // _.forEach(val.tetap.value, (valTetap) => {
            //   this.wbAoa(ws, valTetap.key, "A" + row);
            //   row += 1;
            // });

            row += 1;
          }
        });

        row += 1;
      });
    },

    excelRekap(workbook, sheetName, data) {
      const ws = workbook.Sheets[sheetName];
      var row = 1;
      console.log("excelrekap ALL", data);
      _.forEach(data, (table) => {
        //title
        this.wbAoa(
          ws,
          "REKAP GAJI/UPAH " +
            _.replace(this.convertTglIndonesia(table.tgl), /^1\s/, ""),
          "A" + row,
        );
        row += 1;
        this.wbAoa(ws, "KETERANGAN", "A" + row);
        this.wbAoa(ws, "GAPOK", "B" + row);
        this.wbAoa(ws, "TUNJANGAN", "C" + row);
        this.wbAoa(ws, "PERUSAHAAN", "C" + (row + 1));
        this.wbAoa(ws, "JABATAN", "D" + (row + 1));
        this.wbAoa(ws, "KEMAHALAN", "E" + (row + 1));
        this.wbAoa(ws, "AIR", "F" + (row + 1));
        this.wbAoa(ws, "TRANSPORT", "G" + (row + 1));
        this.wbAoa(ws, "PANGAN", "H" + (row + 1));
        this.wbAoa(ws, "KESEHATAN", "I" + (row + 1));
        this.wbAoa(ws, "POT. ", "J" + row);
        this.wbAoa(ws, "PERSONALIA", "J" + (row + 1));
        this.wbAoa(ws, "JUMLAH", "K" + row);
        this.wbAoa(ws, "BRUTO", "K" + (row + 1));
        this.wbAoa(ws, "T. PPH", "L" + row);
        this.wbAoa(ws, "JUMLAH", "M" + row);
        this.wbAoa(ws, "POT.", "N" + row);
        this.wbAoa(ws, "KESEHATAN", "N" + (row + 1));
        this.wbAoa(ws, "BPJS TK", "O" + row);
        this.wbAoa(ws, "3 PROGRAM", "O" + (row + 1));
        this.wbAoa(ws, "BPJS TK", "P" + row);
        this.wbAoa(ws, "4 PROGRAM", "P" + (row + 1));

        this.wbAoa(ws, "PENSIUN", "Q" + row);
        this.wbAoa(ws, "JIWASRAYA", "Q" + (row + 1));
        this.wbAoa(ws, "POT. PPH", "R" + row);
        this.wbAoa(ws, "YANG", "S" + row);
        this.wbAoa(ws, "DITERIMA", "S" + (row + 1));
        row += 3;

        //table tetap
        _.forEach(table.tetap, (tableTetap) => {
          this.wbAoa(ws, tableTetap.key, "A" + row);
          this.wbAoa(ws, tableTetap.value.gaji_pokok, "B" + row);
          this.wbAoa(ws, tableTetap.value.tun_perusahaan, "C" + row);
          this.wbAoa(ws, tableTetap.value.tun_jabatan, "D" + row);
          this.wbAoa(ws, tableTetap.value.tun_kemahalan, "E" + row);
          this.wbAoa(ws, tableTetap.value.tun_air, "F" + row);
          this.wbAoa(ws, tableTetap.value.tun_transport, "G" + row);
          this.wbAoa(ws, tableTetap.value.tun_pangan, "H" + row);
          this.wbAoa(ws, tableTetap.value.tun_kesehatan, "I" + row);
          this.wbAoa(ws, tableTetap.value.pot_5_persen, "J" + row);
          this.wbAoa(ws, tableTetap.value.jml_bruto, "K" + row);
          this.wbAoa(ws, tableTetap.value.tun_pph, "L" + row);
          this.wbAoa(ws, tableTetap.value.jumlah, "M" + row);
          this.wbAoa(ws, tableTetap.value.pot_kesehatan, "N" + row);
          this.wbAoa(ws, tableTetap.value.pot_bpjs_tk_tiga_program, "O" + row);
          this.wbAoa(ws, tableTetap.value.pot_bpjs_tk_empat_program, "P" + row);
          this.wbAoa(ws, tableTetap.value.pot_pensiun, "Q" + row);
          this.wbAoa(ws, tableTetap.value.pot_pph, "R" + row);
          this.wbAoa(ws, tableTetap.value.total_diterima, "S" + row);

          row += 1;
        });
        row += 2;

        //title KONTRAK
        this.wbAoa(ws, "KETERANGAN", "A" + row);
        this.wbAoa(ws, "(Pekerja Kontrak)", "A" + (row + 1));
        this.wbAoa(ws, "TUNJ.", "I" + row);
        this.wbAoa(ws, "KESEHATAN", "I" + (row + 1));
        this.wbAoa(ws, "POT. ", "J" + row);
        this.wbAoa(ws, "PERSONALIA", "J" + (row + 1));
        this.wbAoa(ws, "JUMLAH", "K" + row);
        this.wbAoa(ws, "BRUTO", "K" + (row + 1));
        this.wbAoa(ws, "GAJI/UPAH YG DIBAYAR", "L" + row);
        this.wbAoa(ws, "POT.", "N" + row);
        this.wbAoa(ws, "KESEHATAN", "N" + (row + 1));
        this.wbAoa(ws, "BPJS TK", "O" + row);
        this.wbAoa(ws, "YANG", "S" + row);
        this.wbAoa(ws, "DITERIMA", "S" + (row + 1));
        row += 3;

        //table kontrak
        _.forEach(table.honor, (tableHonor) => {
          this.wbAoa(ws, tableHonor.key, "A" + row);
          this.wbAoa(
            ws,
            tableHonor.value.jml_bruto - tableHonor.value.tun_kesehatan,
            "B" + row,
          );
          this.wbAoa(ws, tableHonor.value.tun_kesehatan, "I" + row);
          this.wbAoa(ws, tableHonor.value.pot_5_persen, "J" + row);
          this.wbAoa(ws, tableHonor.value.jml_bruto, "K" + row);
          this.wbAoa(
            ws,
            tableHonor.value.jml_bruto -
              tableHonor.value.tun_kesehatan -
              tableHonor.value.pot_5_persen,
            "L" + row,
          );
          this.wbAoa(ws, tableHonor.value.jml_bruto, "M" + row);
          this.wbAoa(ws, tableHonor.value.pot_kesehatan, "N" + row);
          this.wbAoa(ws, tableHonor.value.pot_bpjs_tk_dua_persen, "O" + row);
          this.wbAoa(ws, tableHonor.value.total_diterima, "S" + row);

          row += 1;
        });

        //table keseluruhan
        this.wbAoa(ws, "JUMLAH KESELURUHAN", "A" + row);
        this.wbAoa(ws, table.all[0].value.tun_kesehatan, "I" + row);
        this.wbAoa(ws, table.all[0].value.pot_5_persen, "J" + row);
        this.wbAoa(ws, table.all[0].value.jml_bruto, "K" + row);
        this.wbAoa(ws, table.all[0].value.tun_pph, "L" + row);
        this.wbAoa(ws, table.all[0].value.jumlah, "M" + row);
        this.wbAoa(ws, table.all[0].value.pot_kesehatan, "N" + row);
        this.wbAoa(ws, table.all[0].value.pot_bpjs_tk, "O" + row);
        this.wbAoa(ws, table.all[0].value.pot_bpjs_tk_empat_program, "P" + row);
        this.wbAoa(ws, table.all[0].value.pot_pensiun, "Q" + row);
        this.wbAoa(ws, table.all[0].value.pot_pph, "R" + row);
        this.wbAoa(ws, table.all[0].value.total_diterima, "S" + row);
        row += 2;
        //table total bayar
        this.wbAoa(ws, "Total Bayar", "D" + row);
        this.wbAoa(ws, table.all[0].value.jumlah, "J" + row);

        row += 5;
      });
    },

    excelRekapKontrak(workbook, sheetName, data) {
      const ws = workbook.Sheets[sheetName];
      var row = 1;
      console.log("excelrekap ALL", data);
      _.forEach(data, (table) => {
        //title
        this.wbAoa(
          ws,
          "REKAP GAJI/UPAH PEKERJA KONTRAK BULAN " +
            _.replace(this.convertTglIndonesia(table.tgl), /^1\s/, ""),
          "A" + row,
        );
        row += 1;
        this.wbAoa(ws, "UPAH (UMK)", "B" + row);
        this.wbAoa(ws, "TAMBAHAN UPAH", "C" + row);
        this.wbAoa(ws, "BERDASARKAN", "C" + (row + 1));
        this.wbAoa(ws, "MASA KERJA", "C" + (row + 2));
        this.wbAoa(ws, "TUNJANGAN", "D" + (row + 1));
        this.wbAoa(ws, "KESEHATAN", "D" + (row + 2));
        this.wbAoa(ws, "POT. PERS.", "E" + row);
        this.wbAoa(ws, "JUMLAH", "F" + row);
        this.wbAoa(ws, "TUNJANGAN", "G" + row);
        this.wbAoa(ws, "BPJS T.KERJA", "G" + (row + 1));
        this.wbAoa(ws, "JUMLAH", "H" + row);
        this.wbAoa(ws, "BRUTO", "H" + (row + 1));
        this.wbAoa(ws, "POT.", "I" + row);
        this.wbAoa(ws, "KESEHATAN", "I" + (row + 1));
        this.wbAoa(ws, "POT. BPJS", "J" + row);
        this.wbAoa(ws, "T. KERJA", "J" + (row + 1));
        this.wbAoa(ws, "YANG", "K" + row);
        this.wbAoa(ws, "DITERIMA", "K" + (row + 1));
        row += 3;

        //table
        _.forEach(table.kontrak, (tableKontrak) => {
          this.wbAoa(ws, tableKontrak.key, "A" + row);
          this.wbAoa(ws, tableKontrak.value.honor_umk_jml, "B" + row);
          this.wbAoa(ws, tableKontrak.value.kenaikan_masa_kerja, "C" + row);
          this.wbAoa(ws, tableKontrak.value.tun_kesehatan, "D" + row);
          this.wbAoa(ws, tableKontrak.value.pot_5_persen, "E" + row);
          this.wbAoa(ws, tableKontrak.value.jumlah, "F" + row);
          this.wbAoa(
            ws,
            tableKontrak.value.tun_bpjs_tk_satu_sembilanbelas_persen,
            "G" + row,
          );
          this.wbAoa(ws, tableKontrak.value.jml_bruto, "H" + row);
          this.wbAoa(ws, tableKontrak.value.pot_kesehatan, "I" + row);
          this.wbAoa(
            ws,
            tableKontrak.value.pot_bpjs_tk_satu_sembilanbelas_persen,
            "J" + row,
          );
          this.wbAoa(ws, tableKontrak.value.total_diterima, "K" + row);

          row += 1;
        });

        row += 5;
      });
    },

    async downloadExcelPerbandingan() {
      //PREPARING DATA FOR REKAP TANPA DP AND REKAP KONTRAK
      this.pejabat = await this.commonFunction.getPejabatPengesahan(
        // DateTime.now().startOf("month").toISODate(),
        this.formatDateISO(this.tglGajiAkhir),
      );
      const rekap = await this.fetchDataRekap();

      const workbook = XLSX.utils.book_new();
      const sheetName = "PERBANDINGAN GAJI";
      const sheetNameRekap = "REKAP Terbaru Tanpa DP";
      const sheetNameRekapKontrak = "REKAP KONTRAK";

      XLSX.utils.book_append_sheet(workbook, {}, sheetName);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameRekap);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameRekapKontrak);
      this.excelRekap(workbook, sheetNameRekap, rekap.data);
      this.excelRekapKontrak(workbook, sheetNameRekapKontrak, rekap.data);

      this.excelPerbandingan(workbook, sheetName);

      XLSX.writeFile(
        workbook,
        "Perbandingan Gaji " + this.titleRekap + ".xlsx",
      );
    },
    printKetJustOnce(index) {
      if (index == 0) return true;
      return false;
    },
    convertTglIndonesia(inputDate, monthYear = null) {
      const parsedDate = DateTime.fromISO(inputDate);
      // Format the date in the desired Indonesian format
      var formattedDate = null;
      if (monthYear)
        formattedDate = parsedDate.setLocale("id").toLocaleString({
          month: "long",
          year: "numeric",
        });
      else
        formattedDate = parsedDate.setLocale("id").toLocaleString({
          day: "numeric",
          month: "long",
          year: "numeric",
        });

      return formattedDate;
    },
    printKet(ket) {
      let printPensiun = "<strong>PENSIUN:</strong> <ol>";
      let printKP = "<strong>KP:</strong> <ol>";
      let printKGB = "<strong>KGB:</strong> <ol>";
      let printAbsensi = "<strong>Jumlah Ketidakhadiran</strong> <ol>";
      let printRiwayatPekerjaan =
        "<strong>Perubahan Pekerjaan/Status Kepegawaian:</strong> <ol>";

      if (ket.pensiun) {
        ket.pensiun.forEach((extracted) => {
          printPensiun =
            printPensiun +
            "<li><div class='highlight-ket'>" +
            extracted.nama +
            "</div> " +
            extracted.nik +
            " (" +
            this.convertTglIndonesia(extracted.pensiun_tgl) +
            ") </li>";
        });
      }

      if (ket.kgb) {
        ket.kgb.forEach((extracted) => {
          printKGB =
            printKGB +
            "<li><div class='highlight-ket'>" +
            extracted.pegawai.nama +
            "</div> " +
            extracted.pegawai.nik +
            " (" +
            this.convertTglIndonesia(extracted.tgl) +
            ", " +
            extracted.masa_kerja +
            " tahun)</li>";
        });
      }

      if (ket.kp) {
        ket.kp.forEach((extracted) => {
          printKP =
            printKP +
            "<li><div class='highlight-ket'>" +
            extracted.pegawai.nama +
            "</div> " +
            extracted.pegawai.nik +
            "  (" +
            this.convertTglIndonesia(extracted.tgl) +
            ", " +
            extracted.golongan.nama +
            ")</li>";
        });
      }

      if (ket.absensi) {
        ket.absensi.forEach((extracted) => {
          printAbsensi =
            printAbsensi +
            "<li><div class='highlight-ket'>" +
            extracted.title +
            "</div> <strong>" +
            this.convertTglIndonesia(extracted.currentTitle) +
            ":</strong> " +
            extracted.current +
            ", <strong>" +
            this.convertTglIndonesia(extracted.prevTitle) +
            ":</strong> " +
            extracted.prev +
            "</li>";
        });
      }

      var temp = "";
      var tempPrev = "";
      if (ket.riwayatPekerjaan) {
        ket.riwayatPekerjaan.forEach((data) => {
          if (data.current.unit) temp = temp + "/" + data.current.unit.nama;
          if (data.current.bagian)
            temp =
              temp + ", <strong>Bagian</strong> " + data.current.bagian.nama;
          if (data.current.sub_bagian)
            temp = temp + "/" + data.current.sub_bagian.nama;
          if (data.current.bidang)
            temp =
              temp + ", <strong>Bidang</strong> " + data.current.bidang.nama;
          if (data.current.sub_bidang)
            temp = temp + "/" + data.current.sub_bidang.nama;
          if (data.current.seksi)
            temp = temp + ", <strong>Seksi</strong> " + data.current.seksi.nama;

          let printRiwayatPekerjaanPrev = "";
          if (data.previous) {
            if (data.previous.unit)
              tempPrev = tempPrev + "/" + data.previous.unit.nama;
            if (data.previous.bagian)
              tempPrev =
                tempPrev +
                ", <strong>Bagian</strong> " +
                data.previous.bagian.nama;

            if (data.previous.sub_bagian)
              tempPrev = tempPrev + "/" + data.previous.sub_bagian.nama;
            if (data.previous.bidang)
              tempPrev =
                tempPrev +
                ", <strong>Bidang</strong> " +
                data.previous.bidang.nama;
            if (data.previous.sub_bidang)
              tempPrev = tempPrev + "/" + data.previous.sub_bidang.nama;
            if (data.previous.seksi)
              tempPrev =
                tempPrev +
                ", <strong>Seksi</strong> " +
                data.previous.seksi.nama;
            printRiwayatPekerjaanPrev =
              "<br><span class='text-muted'>[JABATAN LAMA: (" +
              this.convertTglIndonesia(data.previous.tgl_mulai_bekerja) +
              ") <strong>Status Pegawai:</strong> " +
              data.previous.pegawai_status.nama +
              ", <strong>Cabang:</strong> " +
              data.previous.cabang.nama +
              ", <strong>Jabatan:</strong> " +
              data.previous.jabatan.nama +
              " (" +
              data.previous.status_jabatan +
              ") " +
              tempPrev +
              "]</span>";
          }

          printRiwayatPekerjaan =
            printRiwayatPekerjaan +
            "<li><div class='highlight-ket'>" +
            data.current.simpeg_pegawai.nama +
            "</div> " +
            data.current.simpeg_pegawai.nik +
            "  (" +
            this.convertTglIndonesia(data.current.tgl_mulai_bekerja) +
            "); <strong>Status Pegawai:</strong> " +
            data.current.pegawai_status.nama +
            ", <strong>Cabang:</strong> " +
            data.current.cabang.nama +
            ", <strong>Jabatan:</strong> " +
            data.current.jabatan.nama +
            " (" +
            data.current.status_jabatan +
            ") " +
            temp +
            printRiwayatPekerjaanPrev +
            "</li>";

          temp = "";
          tempPrev = "";
        });
      }

      return (
        printPensiun +
        "</ol><br>" +
        printKP +
        "</ol><br>" +
        printKGB +
        "</ol>" +
        "<br>" +
        printRiwayatPekerjaan +
        "</ol><br>" +
        printAbsensi +
        "</ol>"
      );
    },

    setDataStoreKontrak() {
      this.dataSourceKontrak = new PivotGridDataSource({
        fields: [
          {
            caption: "Cabang",
            width: 120,
            dataField: "cabang",
            area: "row",
          },
          {
            dataField: "tgl",
            dataType: "date",
            area: "column",
          },
          {
            caption: "Honor",
            dataField: "honor_umk_jml",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "KMK",
            dataField: "kenaikan_masa_kerja",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kesehatan",
            dataField: "tun_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml tdk hadir",
            dataField: "jml_tdk_hadir",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Tdk Hadir",
            dataField: "pot_5_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tun. BPJS TK",
            dataField: "tun_bpjs_tk_satu_sembilanbelas_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Bruto",
            dataField: "jml_bruto",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Kesehatan",
            dataField: "pot_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJSK TK",
            dataField: "pot_bpjs_tk_satu_sembilanbelas_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Total Diterima",
            dataField: "total_diterima",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
        ],
        store: this.storeKontrak,
      });
    },
    setDataStoreHonor() {
      this.dataSourceHonor = new PivotGridDataSource({
        fields: [
          {
            caption: "Cabang",
            width: 120,
            dataField: "cabang",
            area: "row",
          },
          {
            dataField: "tgl",
            dataType: "date",
            area: "column",
          },
          {
            caption: "Honor",
            dataField: "honor_umk_jml",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "KMK",
            dataField: "kenaikan_masa_kerja",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kesehatan",
            dataField: "tun_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml tdk hadir",
            dataField: "jml_tdk_hadir",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Tdk Hadir",
            dataField: "pot_5_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Bruto",
            dataField: "jml_bruto",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Kesehatan",
            dataField: "pot_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJSK TK",
            dataField: "pot_bpjs_tk_dua_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Total diterima",
            dataField: "total_diterima",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
        ],
        store: this.storeHonor,
      });
    },
    setDataStoreTetap() {
      this.dataSourceTetap = new PivotGridDataSource({
        fields: [
          {
            caption: "Cabang",
            width: 120,
            dataField: "cabang",
            area: "row",
          },
          {
            caption: "Bagian",
            width: 120,
            dataField: "bagian",
            area: "row",
          },

          {
            dataField: "tgl",
            dataType: "date",
            area: "column",
          },
          {
            caption: "Gapok",
            dataField: "gaji_pokok",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },

          {
            caption: "Tunj. Perusahaan",
            dataField: "tun_perusahaan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Jabatan",
            dataField: "tun_jabatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kemahalan",
            dataField: "tun_kemahalan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Air",
            dataField: "tun_air",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Transport",
            dataField: "tun_transport",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Pangan",
            dataField: "tun_pangan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kesehatan",
            dataField: "tun_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Tdk Hadir",
            dataField: "jml_tdk_hadir",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Tdk Hadir",
            dataField: "pot_5_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Bruto",
            dataField: "jml_bruto",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. PPH",
            dataField: "tun_pph",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Kesehatan",
            dataField: "pot_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJS TK 3",
            dataField: "pot_bpjs_tk_tiga_program",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJS TK 4",
            dataField: "pot_bpjs_tk_empat_program",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Pensiun Jiwasraya",
            dataField: "pot_pensiun",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. PPH",
            dataField: "pot_pph",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Total Diterima",
            dataField: "total_diterima",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
        ],
        store: this.storeTetap,
      });
    },
    setDataStoreTetap2() {
      this.dataSourceTetap = new PivotGridDataSource({
        fields: [
          {
            caption: "Cabang",
            width: 120,
            dataField: "cabang",
            area: "row",
          },
          {
            dataField: "tgl",
            dataType: "date",
            area: "column",
          },
          {
            caption: "Gapok",
            dataField: "gaji_pokok",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },

          {
            caption: "Tunj. Perusahaan",
            dataField: "tun_perusahaan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Jabatan",
            dataField: "tun_jabatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kemahalan",
            dataField: "tun_kemahalan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Air",
            dataField: "tun_air",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Transport",
            dataField: "tun_transport",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Pangan",
            dataField: "tun_pangan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kesehatan",
            dataField: "tun_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Tdk Hadir",
            dataField: "jml_tdk_hadir",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Tdk Hadir",
            dataField: "pot_5_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Bruto",
            dataField: "jml_bruto",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. PPH",
            dataField: "tun_pph",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Kesehatan",
            dataField: "pot_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJS TK 3",
            dataField: "pot_bpjs_tk_tiga_program",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJS TK 4",
            dataField: "pot_bpjs_tk_empat_program",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Pensiun Jiwasraya",
            dataField: "pot_pensiun",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. PPH",
            dataField: "pot_pph",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Total Diterima",
            dataField: "total_diterima",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
        ],
        store: this.storeTetap,
      });
    },
    setDataStoreDireksi() {
      this.dataSourceDireksi = new PivotGridDataSource({
        fields: [
          {
            caption: "Cabang",
            width: 120,
            dataField: "cabang",
            area: "row",
          },
          {
            dataField: "tgl",
            dataType: "date",
            area: "column",
          },
          {
            caption: "Gapok",
            dataField: "gaji_pokok",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },

          {
            caption: "Tunj. Perusahaan",
            dataField: "tun_perusahaan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Jabatan",
            dataField: "tun_jabatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kemahalan",
            dataField: "tun_kemahalan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Air",
            dataField: "tun_air",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Transport",
            dataField: "tun_transport",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Pangan",
            dataField: "tun_pangan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kesehatan",
            dataField: "tun_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Tdk Hadir",
            dataField: "jml_tdk_hadir",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Tdk Hadir",
            dataField: "pot_5_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Bruto",
            dataField: "jml_bruto",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. PPH",
            dataField: "tun_pph",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Kesehatan",
            dataField: "pot_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJS TK 3",
            dataField: "pot_bpjs_tk_tiga_program",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJS TK 4",
            dataField: "pot_bpjs_tk_empat_program",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Pensiun Jiwasraya",
            dataField: "pot_pensiun",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. PPH",
            dataField: "pot_pph",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Total Diterima",
            dataField: "total_diterima",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
        ],
        store: this.storeDireksi,
      });
    },

    formatNumber(number) {
      if (!isNaN(parseFloat(number)) && isFinite(number)) {
        // Format the number with thousands separators
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return number; // Return the original value if it's not numeric
      }
    },

    async validateFilter(e) {
      const result = e.validationGroup.validate();

      if (!result.isValid) return 0;

      // this.titleRekap = this.convertTglIndonesia(this.tglGajiAwal, true);
      this.titleRekap =
        this.convertTglIndonesia(this.formatDateISO(this.tglGajiAwal), true) +
        " - " +
        this.convertTglIndonesia(this.formatDateISO(this.tglGajiAkhir), true);

      this.popupLoadingVisible = true;
      this.storeDireksi = await this.fetchData(1);
      this.setDataStoreDireksi();

      console.log("debug storeDireksi", this.storeDireksi);
      console.log("debug dataSourceDireksi", this.dataSourceDireksi);

      this.storeTetap = await this.fetchData(2);
      this.setDataStoreTetap();

      this.storeHonor = await this.fetchData(4);
      this.setDataStoreHonor();

      this.storeKontrak = await this.fetchData(5);
      this.setDataStoreKontrak();

      await this.fetchDataPerubahan();
      this.popupLoadingVisible = false;
    },

    async validateFilterFromUrl() {
      // this.titleRekap = this.convertTglIndonesia(this.tglGajiAwal, true);
      this.titleRekap =
        this.convertTglIndonesia(this.formatDateISO(this.tglGajiAwal), true) +
        " - " +
        this.convertTglIndonesia(this.formatDateISO(this.tglGajiAkhir), true);

      this.popupLoadingVisible = true;
      this.storeDireksi = await this.fetchData(1);
      this.setDataStoreDireksi();

      this.storeTetap = await this.fetchData(2);
      this.setDataStoreTetap();

      this.storeHonor = await this.fetchData(4);
      this.setDataStoreHonor();

      this.storeKontrak = await this.fetchData(5);
      this.setDataStoreKontrak();

      await this.fetchDataPerubahan();
      this.popupLoadingVisible = false;
    },

    onExporting(e, title) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Rekap Gaji");

      exportPivotGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Rekap Gaji " + title + " " + this.titleRekap + ".xlsx",
          );
        });
      });
      e.cancel = true;
    },
    formatDateISO(dateOri) {
      const date = DateTime.fromJSDate(new Date(dateOri));
      return date.toFormat("yyyy-MM-dd");
    },
    async fetchData(pegawaiStatusId) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        pegawai_status_id: pegawaiStatusId,
        tgl_gaji_awal: this.formatDateISO(this.tglGajiAwal),
        tgl_gaji_akhir: this.formatDateISO(this.tglGajiAkhir),
        approved: this.approvedOnly,
      };
      const response = await axios.post(
        `${API_BASE_URL}/rekap_gaji_pivot`,
        data,
        config,
      );

      return response.data.pivot;
    },
    async fetchDataPerubahan() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        tgl_gaji_awal: this.formatDateISO(this.tglGajiAwal),
        tgl_gaji_akhir: this.formatDateISO(this.tglGajiAkhir),
        status_gaji: this.approvedOnly,
      };

      // const responsePerubahan = await axios.post(
      //   `${API_BASE_URL}/rekap_gaji_perubahan_data_pegawai`,
      //   data,
      //   config
      // );
      const responsePerubahan = await axios.post(
        `${API_BASE_URL}/rekap_gaji_perbandingan`,
        data,
        config,
      );
      this.storePerubahan = responsePerubahan.data;
      this.storePerbandingan = responsePerubahan.data;

      return;
    },
    async fetchDataRekap() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        tgl_gaji_awal: this.formatDateISO(this.tglGajiAwal),
        tgl_gaji_akhir: this.formatDateISO(this.tglGajiAkhir),
        approved: this.approvedOnly,
      };
      const response = await axios.post(
        `${API_BASE_URL}/rekap_gaji`,
        data,
        config,
      );

      return response;
    },
  },
};
</script>
